// Import model
import { StartCompanyAddTaskRequest } from '../models/StartCompanyAddTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartCompanyAddTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class StartCompanyAddTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a StartCompanyAddTaskRequest instance
   */
  static deserialize(json: string): StartCompanyAddTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartCompanyAddTaskRequest instance
   */
  static fromObject(obj: any): StartCompanyAddTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartCompanyAddTaskRequest');
    }


    const instance: StartCompanyAddTaskRequest = {
      dueDate: obj['DueDate'] as string | undefined,
      priority: obj['Priority'] as string | undefined,
      name: obj['Name'] as string | undefined,
      content: obj['Content'] as string | undefined,
      assignedUserId: obj['AssignedUserId'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartCompanyAddTaskRequest instances
   */
  static deserializeArray(json: string): StartCompanyAddTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartCompanyAddTaskRequest instance to a JSON string
   */
  static serialize(instance: StartCompanyAddTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartCompanyAddTaskRequest instance to a plain object
   */
  static toObject(instance: StartCompanyAddTaskRequest): any {
    return {
      'DueDate': instance.dueDate,
      'Priority': instance.priority,
      'Name': instance.name,
      'Content': instance.content,
      'AssignedUserId': instance.assignedUserId,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartCompanyAddTaskRequest instances to a JSON string
   */
  static serializeArray(instances: StartCompanyAddTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
